import { render, staticRenderFns } from "./TiptapEditor.vue?vue&type=template&id=3df4e845&scoped=true"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"
import style0 from "./TiptapEditor.vue?vue&type=style&index=0&id=3df4e845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df4e845",
  null
  
)

export default component.exports